import { forwardRef, useEffect, useState } from "react"
import { useScreenSize } from "lib/@components/use-screen-size"
import { Box } from "@mui/material"
import { MeasureYPosition } from "lib/@components/measure-y-position"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import noop from "lib/noop"

export const FitInRemainingSpace = forwardRef(function FitInRemainingVerticalSpace(
    { leaveSpace = 0, onMeasureHeight = noop, overflow = "auto", setHeight, Component = Box, ...props },
    ref
) {
    const { isPDF } = useBoundContext()
    const { innerHeight } = useScreenSize()
    const [position, setPosition] = useState(Number.POSITIVE_INFINITY)
    useEffect(() => {
        onMeasureHeight(Math.max(0, innerHeight - leaveSpace - position))
    }, [position, innerHeight, leaveSpace, onMeasureHeight])
    return isPDF ? (
        <Component {...props} />
    ) : (
        <>
            <MeasureYPosition onPosition={setPosition} />
            <Component
                ref={ref}
                {...props}
                sx={{
                    ...props.sx,
                    maxHeight: Math.max(0, innerHeight - leaveSpace - position),
                    height: setHeight && Math.max(0, innerHeight - leaveSpace - position),
                    overflowY: overflow,
                }}
            />
        </>
    )
})
